import React, { useEffect, useState } from 'react';
import { Button, Container, Form } from 'react-bootstrap';

import { UpdatePasswordStyles } from './style';
import { passwordSchema } from '../constants';

import { BsQuestionCircleFill } from 'react-icons/bs';
import Tooltip from 'reusable/Tooltip';
import useQuery from 'reusable/customHooks/useQuery';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useUpdatePasswordMutation } from 'services/api/ums';
import useHeader from 'containers/App/Header/useHeader';

function UpdatePasswordPage() {
  useHeader('Update Password');
  const [query] = useQuery();
  const history = useHistory();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const token = query.get('token');
  const email = query.get('email');

  const [updatePassword, updatePasswordState] = useUpdatePasswordMutation();

  useEffect(() => {
    if (updatePasswordState.isError) {
      setError(get(updatePasswordState, 'error.data.message'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatePasswordState.isError]);

  useEffect(() => {
    if (updatePasswordState.isSuccess) {
      toast.success(get(updatePasswordState, 'data.message'));
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatePasswordState.isSuccess]);

  return (
    <UpdatePasswordStyles>
      <Container fluid className="update-password-container">
        <Form.Group
          className={
            !password
              ? 'form-group'
              : passwordSchema.validate(password)
                ? 'form-group success'
                : 'form-group error'
          }
        >
          <Form.Label>
            New Password *
            <Tooltip
              tooltipValue={
                <ul>
                  <li>
                    Can use letters, numbers, and special characters. No spaces.
                  </li>
                  <li>Minimum length 8 characters</li>
                  <li> At least 1 uppercase character At</li>
                  <li>least 1 lowercase character</li>
                </ul>
              }
              placement="right"
            >
              <div className="help-password">
                <BsQuestionCircleFill />
              </div>
            </Tooltip>
          </Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </Form.Group>
        <Form.Group
          className={
            !confirmPassword
              ? 'form-group'
              : password === confirmPassword
                ? 'form-group success'
                : 'form-group error'
          }
        >
          <Form.Label>Confirm Password *</Form.Label>
          <Form.Control
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
          />
        </Form.Group>
        {error && <div className="error-message">{error}</div>}
        <Button
          disabled={
            !password ||
            !passwordSchema.validate(password) ||
            password !== confirmPassword ||
            updatePasswordState.isLoading
          }
          onClick={() => updatePassword({ email, token, password })}
        >
          Change Password
        </Button>
      </Container>
    </UpdatePasswordStyles>
  );
}

export default UpdatePasswordPage;
